/**
 * @file 主题
 * @date 2022-11-23
 */

import { DEFAULT_THEME } from '@/config/theme';

const state = {
    /**
     * 当前主题，值为light与dark，默认light
     */
    theme: DEFAULT_THEME,
};

const getters = {
    isLight: (state) => state.theme === 'light', // 是否白天主题
};

const mutations = {
    SET_THEME(state, payload) {
        const body = document.querySelector('html');
        const htmlClassList = Array.from(body?.classList);
        const withoutThemeClass = htmlClassList.filter((cn) => (!cn.match(/dark|light/)));

        body.setAttribute('class', [...withoutThemeClass, payload, `theme-${payload}`].join(' '));
        state.theme = payload;
    },
};

const actions = {
    INIT({ commit }, theme) {
        commit('SET_THEME', theme);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
